<template>
    <popup-modal :show="show">
        <template #content>
            <div class="step-view">
                <div class="header">
                    <h2>{{ headerText }}</h2>
                </div>
                <div class="steps-wrapper" :style="`--index: ${activeStep}`">
                    <div class="step flex-column-gap" :class="{ active: activeStep === 0}">
                        <div>
                            <p class="message">
                                Door jouw eigen speler te selecteren krijg je inzicht in jouw statistieken!<br>
                                <br>
                                Selecteer jouw speler 👇🏼
                            </p>
                        </div>
                        <div class="users-wrapper flex-column-gap">
                            <custom-button v-for="user in gameUsers" :key="user.id" v-parse-emojis size="medium" @click="handleUserSelected(user)">{{ user.name }}</custom-button>
                        </div>
                    </div>
                    <div class="step step-selfie flex-column-gap" :class="{ active: activeStep === 1}">
                        <div v-if="selectedUser && selectedUser.hasAvatar" class="flex-column align-center">
                            <avatar :userId="selectedUser.id" :avatar="selectedUser.base64avatar" style="width: 120px; height: 120px; margin-bottom: 16px;"></avatar>
                            <p class="message">Gezellig dat je er weer bent 🥳</p>
                        </div>
                        <div v-else-if="selectedUser">
                            <p class="message">Maak nu een leuke profielfoto! 👇🏼</p>
                        </div>
                        <div v-if="selectedUser && !selectedUser.base64avatar">
                            <custom-button class="selfie-button" size="medium" @click="clickInput">Maak een selfie</custom-button>
                            <input style="display: none" type="file" id="selfie-register" capture="user" accept="image/*" @input="handleUploadAvatar"/>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template #footer>
            <div class="buttons">
                <custom-button class="button" :class="{ show: activeStep === 1}" variation="white" size="medium" @click="activeStep = 0">
                    <div class="flex align-center justify-center" style="gap:4px;margin-left:-8px;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
                            <path stroke-width="1.2" stroke="#2f343a" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
                        </svg>
                        <span>Terug</span>
                    </div>
                </custom-button>
                <custom-button class="button show" :variation="cancelText === 'Naar spel' ? 'primary' : 'white'" size="medium" @click="handleCancel">{{ cancelText }}</custom-button>
            </div>
        </template>
    </popup-modal>
</template>

<script>
import { uploadAvatar } from '@/utils.js';

import PopupModal from '@/components/PopupModal.vue';
import CustomButton from '@/components/CustomButton.vue';
import Avatar from '@/components/Avatar.vue';

export default {
    name: 'register-user-modal',
    components: {
        PopupModal,
        CustomButton,
        Avatar,
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        gameUsers: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            selectedUser: null,
            translateX: 0,
            activeStep: 0
        }
    },
    methods: {
        handleUserSelected(user) {
            this.selectedUser = user;
            this.activeStep = 1;
        },
        clickInput() {
            document.getElementById('selfie-register').click();
        },
        async handleUploadAvatar(event) {
            const file = event.target.files[0];

            const avatar = await uploadAvatar(this.selectedUser.id, file);
            if(!avatar) return
            
            this.selectedUser.base64avatar = avatar;
            this.handleRegisterUser();
        },
        handleRegisterUser() {
            localStorage.setItem('you', JSON.stringify(this.selectedUser));
            localStorage.setItem('favoriteUserIds', JSON.stringify([ this.selectedUser.id ]));
            this.$emit('close', this.selectedUser);
        },
        handleCancel() {
            if(this.selectedUser && this.activeStep === 1) this.handleRegisterUser();
            else this.$emit('close');
        }
    },
    computed: {
        headerText: function() {
            return this.activeStep === 1 ? `Welkom ${this.selectedUser.name}` : 'Een nieuw gezicht!';
        },
        cancelText: function() {
            if (this.activeStep === 0) return 'Ik ben geen speler';

            return this.selectedUser?.hasAvatar ? 'Naar spel' : 'Niet nu 🙈'
        },
    }
}
</script>

<style lang="scss" scoped>

.step-view {
    width: 100%;
    overflow: hidden;
    padding: 10px;
    margin: -10px;

    .header {
        text-align: center;
        color: white;
        margin-bottom: 18px;
    }
    
    .steps-wrapper {
        display: flex;
        translate: calc(var(--index) * -50% - 10px) 0;
        width: calc(200% + 40px);
        transition: .4s cubic-bezier(.7,.05,.31,.95);
    }

    .step {
        width: calc(100% + 20px);
        max-height: 0;
        transition: .4s ease-out;
        padding-inline: 10px;
        overflow: hidden;
        
        &.active {
            max-height: 50vh;
        }
    }
    .step-selfie {
        overflow: hidden !important;
        margin-bottom: 12px;

        .selfie-button {
            margin-top: 12px;
        }
    }

}

.users-wrapper {
    padding-block: 12px;
    max-height: 300px;
    overflow-x: hidden;
    overflow-y: auto;
}

.buttons {
    display: flex;
    gap: 12px;
    width: 100%;
    overflow: hidden;
    padding: 10px;
    margin: -10px;

    .button {
        margin-left: calc(-100% - 10px);
    
        &.show {
            margin: 0;
        }
    }
}

</style>